// extracted by mini-css-extract-plugin
module.exports = {"Container":"CardSearchPage_Container__f2w0e"};